import ConfirmPopup from "primevue/confirmpopup";
import { $dt } from "@primevue/themes";
import { absolutePosition, getOffset, addClass } from "@primeuix/utils/dom";

// This is temporary, until https://github.com/primefaces/primevue/issues/5915
// is merged (before removing this, please confirm that the arrow is pointing
// **exactly** to the middle of the target element).
ConfirmPopup.methods.alignOverlay = function () {
    absolutePosition(this.container, this.target, false);
    var containerOffset = getOffset(this.container);
    var targetOffset = getOffset(this.target);
    var arrowLeft = 0;
    if (containerOffset.left < targetOffset.left) {
        arrowLeft = targetOffset.left - containerOffset.left;
    }

    this.container.style.setProperty(
        $dt("confirmpopup.arrow.left").name,
        `calc(${arrowLeft}px + ${$dt("confirmpopup.arrow.offset").value} - 1px)`
    );
    if (containerOffset.top < targetOffset.top) {
        this.container.setAttribute("data-p-confirmpopup-flipped", "true");
        !this.isUnstyled && addClass(this.container, "p-confirmpopup-flipped");
    }
};

export { ConfirmPopup };
